// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Zm-z","badgeLink":"_m-z","category":"an-z"};